import React, { memo, useRef, useState } from "react";
import {
  Button,
  FloatingLabel,
  Row,
  Col,
  Form,
  Spinner,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import {
  FORMATS,
  SIZES,
  convertAndDownloadQrImage,
} from "../../../page/ThirdScreen/generatorQR";
import QrCanvasImage from "../EntryQr/QrCanvasImage";
import { webView } from "../../../variables/webView";
import axios from "axios";

const MemoizedQrCanvasImage = memo(QrCanvasImage);

export default function DownLoadModal({
  handleClose,
  trans,
  qrDescription,
  qrLink,
  title,
  id,
}) {
  const svgWrapperRef = useRef(null);

  const [downloadQrType, setDownloadQrType] = useState(FORMATS[0]);
  const [qrSize, setQrSize] = useState(SIZES[2].size);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    if (webView) {
      await webViewDownload();
    } else {
      await convertAndDownloadQrImage(
        svgWrapperRef.current,
        title,
        qrSize,
        downloadQrType
      );
    }
    setIsDownloading(false);
    handleClose();
  };

  const webViewDownload = async () => {
    try {
      const { data } = await axios(`/entry/${id}/download/png/ifExists`);
      if (!data.url) {
        const alertError = document.querySelector("#entryAlertError");
        alertError.classList.remove("d-none");
        alertError.querySelector("div").innerText = trans["Access denied"];
        setTimeout(() => alertError?.classList.add("d-none"), 5000);
        return;
      }
      await window.ReactNativeWebView.postMessage(data.url);
    } catch (err) {
      console.error("Error downloading image:", err);
    }
  };

  return (
    <Modal show={true} onHide={handleClose} centered className="text-dark">
      <Modal.Header className="border-0">
        <Modal.Title className="d-flex justify-content-between align-items-center w-100">
          {trans["Download QR Code"]}
          <Button className="border-0 bg-white" onClick={handleClose}>
            <img src="/static/pages/admin-img/close.svg" />
          </Button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="visually-hidden">
          <MemoizedQrCanvasImage
            qrDescription={qrDescription}
            qrLink={qrLink}
            wrapRef={svgWrapperRef}
            canvasQr={false}
          />
        </div>

        <h6 className="text-center text-title fw-normal">
          {trans["Please select QR Code file type and size"]}
        </h6>
        <Row className="gx-3 gy-2 mb-4 mt-2">
          <Col sm={6}>
            <FloatingLabel label={trans["Format"]}>
              <Form.Select
                value={downloadQrType}
                onChange={(e) => setDownloadQrType(e.target.value)}
              >
                {FORMATS.map((item) => (
                  <option key={item} value={item}>
                    {item.toUpperCase()}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col sm={6}>
            <FloatingLabel label={trans["Size"]}>
              <Form.Select
                value={qrSize}
                onChange={(e) => setQrSize(Number(e.target.value))}
              >
                {SIZES.map((item) => (
                  <option key={item.label} value={item.size}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
        </Row>
        <Button
          variant="primary"
          className="text-white w-100 fw-bold py-3"
          onClick={handleDownload}
          disabled={isDownloading}
        >
          {isDownloading ? (
            <>
              <Spinner className="me-2" animation="border" size="sm" />
              {trans["Download started"]}
            </>
          ) : (
            <>
              <img
                src="/static/pages/admin-img/download.svg"
                className="me-2 pb-1"
                alt="download"
              />
              {trans["Download QR Code"]}
            </>
          )}
        </Button>
      </Modal.Body>
    </Modal>
  );
}
